export const esData = `
  <div class="paragraph">
    <div class="page-title">Preguntas Frecuentes sobre el Programa de Recompra (Trade-In)</div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué debo considerar al vender un teléfono móvil a eSwop?</div>
    <div class="text-box">
      <div class="text">
      El teléfono móvil debe estar restablecido, con todos los datos personales y PINs eliminados. Para iPhones: asegúrate de que el dispositivo esté desconectado de tu cuenta de iCloud.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué pasa si la condición de mi teléfono es evaluada de manera diferente a la mía?</div>
    <div class="text-box">
      <div class="text">
        Si eso sucede, te notificaremos y te proporcionaremos una oferta de precio revisada basada en nuestra  valuador. Además, si nuestro equipo evalúa la condición como mejor de lo que indicaste, te lo haremos saber.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cuándo se revisará mi dispositivo?</div>
    <div class="text-box">
      <div class="text">
      La mayoría de los envíos se revisan con nuestro software de inspección en pocos minutos después de su llegada.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué sucede con mis datos?</div>
    <div class="text-box">
      <div class="text">
        Por favor, asegúrate de que todos tus datos hayan sido eliminados antes de enviarnos tu teléfono móvil. Si quedan datos en el dispositivo al llegar, te notificaremos y solicitaremos tu permiso para eliminarlos.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar los accesorios?</div>
    <div class="text-box">
      <div class="text">
        Por favor, asegúrate de que todos tus datos hayan sido eliminados antes de enviarnos tu teléfono móvil. Si quedan datos en el dispositivo al llegar, te notificaremos y solicitaremos tu permiso para eliminarlos.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar mis auriculares?</div>
    <div class="text-box">
      <div class="text">
      No, por razones de higiene, los desecharemos.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar la factura de mi teléfono móvil?</div>
    <div class="text-box">
      <div class="text">
      No, puedes conservarla para tus registros. No la necesitamos.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué pasa si mi dispositivo está en malas condiciones?</div>
    <div class="text-box">
      <div class="text">
      Evaluaremos tu dispositivo utilizando un estándar claro y justo, te enviaremos la valoración por correo electrónico lo antes posible.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Puedo vender un teléfono con bloqueo de SIM?</div>
    <div class="text-box">
      <div class="text">
      No, lamentablemente, no podemos comprar teléfonos móviles que tengan un bloqueo de SIM.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿eSwop solo compra teléfonos móviles o también otros dispositivos?</div>
    <div class="text-box">
      <div class="text">
      También compramos otros dispositivos electrónicos, como tabletas, relojes y laptops.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cómo calificáis los teléfonos móviles y otros dispositivos que se venden en vuestra tienda de Amazon, Back Market y Wallapop?</div>
    <div class="text-box">
      <div class="text">
      Realizamos una revisión diagnóstica y visual completa en todos nuestros teléfonos y tabletas. Cada dispositivo se prueba de forma individual y se le asigna una calificación basada en su apariencia física. Las calificaciones se explican a continuación:
      </div>
      <div class="text">
      Nuevo en caja: Producto en su caja original. No presenta señales de uso y está en perfectas condiciones de funcionamiento.
      </div>
      <div class="text">
      Reacondicionado en condición como nuevo: Producto premium ‘como nuevo’ a un precio reducido. No presenta señales de uso y está empaquetado en nuestra caja.
      </div>
      <div class="text">
      Reacondicionado en excelente condición: Producto en excelente estado con desgaste aislado en la parte delantera, trasera o los laterales. Totalmente funcional.
      </div>
      <div class="text">
      Reacondicionado en buena condición: Producto en estado promedio con señales de uso. Presenta desgaste en la parte delantera, trasera o laterales. Totalmente funcional.
      </div>
      <div class="text">
      Reacondicionado en condición normal: Producto usado en estado justo con señales de desgaste intenso en la parte delantera, trasera o laterales. Totalmente funcional y con una salud de batería superior al 70%.
      </div>
      <div class="text">
      Todos nuestros productos han sido probados por un especialista en dispositivos electrónicos y revisados para garantizar su calidad antes de ser enviados.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Puedo cancelar mi venta?</div>
    <div class="text-box">
      <div class="text">
      Por supuesto. Sin embargo, esto solo se puede hacer hasta el momento en que procesemos el pago hacia ti.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cómo puedo cancelar un pedido?</div>
    <div class="text-box">
      <div class="text">
      Si has recibido un correo de confirmación de venta pero deseas cancelar el pedido, puedes enviar un correo a nuestro equipo de Atención al Cliente a <span class="email">order@eswop.eu.com.</span> Ellos te ayudarán con la cancelación.
      </div>
    </div>
  </div>
`;
